export const ASTRONAUT_LINE_CHART_TOOLTIP_WIDTH = 330;
export const VECTOR_LINE_CHART_TOOLTIP_WIDTH = 200;
export const LINE_CHART_TOOLTIP_HEIGHT = 60;

export const STATUS_CHART_TOOLTIP_WIDTH_IN_PX = 200;

export const TOOLTIP_ARROW_LEFT_MARGIN = 4;
export const TOOLTIP_ARROW_RIGHT_MARGIN = 12;
export const DEFAULT_SCREEN_WIDTH_OFFSET = 50;
export const DISTANCE_FROM_MOUSE_X = 20;

export const TOOLTIP_CIRCLE_STYLES = {
  display: 'inline-block',
  width: '9px',
  height: '9px',
  borderRadius: '50%',
  marginRight: '6px',
};
